
import { useState, useEffect } from 'react';

export const useInstallState = () => {
  const [installPressed, setInstallPressed] = useState(false);

  // Reset install state when component mounts (new app detail page)
  useEffect(() => {
    console.log('Install state reset on new app detail page');
    setInstallPressed(false);
  }, []);

  const handleInstallPress = () => {
    console.log('handleInstallPress called - setting installPressed to true');
    console.log('Current installPressed state:', installPressed);
    setInstallPressed(true);
    console.log('Install state updated, installPressed should now be true');
  };

  const resetInstallState = () => {
    console.log('Resetting install state');
    setInstallPressed(false);
  };

  return {
    installPressed,
    handleInstallPress,
    resetInstallState
  };
};
